import { defineMessages } from 'react-intl-next';

export const messages: {
	searchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyLinkIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholderDefault: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholderWithAtlassianIntelligence: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholderWithRovo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchIconLabel: {
		id: 'input_search_icon_label',
		defaultMessage: 'Search',
		description: 'Label text for search icon',
	},
	clearIconLabel: {
		id: 'input_clear_icon_label',
		defaultMessage: 'Clear search',
		description: 'Label text for clear search button',
	},
	copyLinkIconLabel: {
		id: 'input_copy_link_icon_label',
		defaultMessage: 'Copy link',
		description: 'Label text for copy link icon',
	},
	inputPlaceholderDefault: {
		id: 'input_placeholder_default',
		defaultMessage: 'Search for anything',
		description: 'Placeholder text in primary search input',
	},
	inputPlaceholderWithAtlassianIntelligence: {
		id: 'input_placeholder_with_atlassian_intelligence',
		defaultMessage: 'Search or ask anything',
		description: 'Placeholder text in primary search input with Atlassian Intelligence',
	},
	inputPlaceholderWithRovo: {
		id: 'input_placeholder_with_rovo',
		defaultMessage: 'Search or ask Rovo',
		description: 'Placeholder text in primary search input with Rovo',
	},
});
